import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { TableBodyCell, Menu, IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Link } from 'react-router-dom';
import { DownloadDocumentDialog } from 'app/domains/filesystem/components/DownloadDocumentDialog';
import { useMobile } from 'shared/domains/common-ui';
export function ContextMenuCell(props) {
    const { documentId, openUrl, download, onDuplicate, onMove, onRename, onDelete, onEditAccess, accessLevel } = props;
    const [downloadDialog, setDownloadDialog] = useState(false);
    const isMobile = useMobile();
    const stickyColumn = isMobile ? 'right' : undefined;
    const restricted = accessLevel !== 'full';
    const handleDownload = () => {
        setDownloadDialog(true);
    };
    return (<TableBodyCell removeExtraPadding headers="filesystemtable-contextmenu" stickyColumn={stickyColumn}>
      <Menu.Root target={<IconButton appearance="ghost" size="xs">
            <Falcon icon="ellipsis-h"/>
          </IconButton>}>
        {Boolean(openUrl) && (<Menu.Item asChild>
            <Link to={openUrl}>
              <Falcon icon="eye"/>
              <Menu.ItemText primary={t({ message: 'Open', comment: 'Filesystem: Context menu item' })}/>
            </Link>
          </Menu.Item>)}

        {onRename && (<Menu.Item onClick={onRename} disabled={restricted}>
            <Falcon icon="pen-to-square"/>
            <Menu.ItemText primary={t({ message: 'Rename', comment: 'Filesystem: Context menu item' })}/>
          </Menu.Item>)}

        {onMove && (<Menu.Item onClick={onMove} disabled={restricted}>
            <Falcon icon="folder"/>
            <Menu.ItemText primary={t({ message: 'Move', comment: 'Filesystem: Context menu item' })}/>
          </Menu.Item>)}

        {onEditAccess && (<Menu.Item onClick={onEditAccess} disabled={restricted}>
            <Falcon icon="lock"/>
            <Menu.ItemText primary={t({ message: 'Manage access', comment: 'Filesystem: Context menu item' })}/>
          </Menu.Item>)}

        {(onDuplicate || download) && (<Fragment>
            <Menu.Divider />

            {onDuplicate && (<Menu.Item onClick={onDuplicate} disabled={restricted}>
                <Falcon icon="copy"/>
                <Menu.ItemText primary={t({ message: 'Copy', comment: 'Filesystem: Context menu item' })}/>
              </Menu.Item>)}

            {download && (<Menu.Item onClick={handleDownload} disabled={restricted}>
                <Falcon icon="download"/>
                <Menu.ItemText primary={t({ message: 'Download', comment: 'Filesystem: Context menu item' })}/>
              </Menu.Item>)}
          </Fragment>)}

        {onDelete && (<Fragment>
            <Menu.Divider />

            <Menu.Item onClick={onDelete} disabled={restricted}>
              <Falcon icon="trash"/>
              <Menu.ItemText primary={t({ message: 'Delete', comment: 'Filesystem: Context menu item' })}/>
            </Menu.Item>
          </Fragment>)}
      </Menu.Root>

      {downloadDialog && documentId && (<DownloadDocumentDialog id={documentId} onClose={() => setDownloadDialog(false)}/>)}
    </TableBodyCell>);
}
